var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs11":"","sm8":"","md6":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{staticClass:"gradient",attrs:{"dark":""}},[_vm._t("header")],2),_vm._v(" "),_c('v-card-text',[_vm._t("body")],2),_vm._v(" "),_c('v-card-actions',[_vm._t("footer")],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09d0bfa7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Card.vue
// module id = 1271
// module chunks = 1